import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["data-vendor-code"]
const _hoisted_2 = {
  key: 0,
  class: "badge badge-primary"
}

import * as moment from 'moment'
import { reactive, ref } from 'vue'
import AppIconLoadingButton from "@/components/app/AppIconLoadingButton.vue";
import SilpoProductPriceChart from "@/components/shopping/silpo/SilpoProductPriceChart.vue";
import SilpoProductPricesInStores from "@/components/shopping/silpo/SilpoProductPricesInStores.vue";

interface Props {
  vendorCode: number,
  buyingCount?: number,
  priceChartHeight: string
}

interface Visibility {
  prices: boolean,
  pricesInStores: boolean
}

interface Lock {
  pricesLoading: boolean,
  pricesInStoresLoading: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoProductInfoActions',
  props: {
    vendorCode: null,
    buyingCount: { default: 0 },
    priceChartHeight: null
  },
  setup(__props: any) {

const props = __props as { vendorCode: number, buyingCount: number, priceChartHeight: string };


const visibility = reactive<Visibility>({ prices: false, pricesInStores: false })
const lock = reactive<Lock>({ pricesLoading: false, pricesInStoresLoading: false })
const date = ref(moment().format('YYYY-MM-DD'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-vendor-code": props.vendorCode
  }, [
    _createElementVNode("div", null, [
      _createVNode(AppIconLoadingButton, {
        loading: lock.pricesLoading,
        disabled: lock.pricesLoading,
        class: "me-1",
        icon: "chart-bar",
        "button-small": true,
        "button-type": "light",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visibility.prices = !visibility.prices))
      }, null, 8, ["loading", "disabled"]),
      _createVNode(AppIconLoadingButton, {
        loading: lock.pricesInStoresLoading,
        disabled: lock.pricesInStoresLoading,
        icon: "store",
        "button-small": true,
        "button-type": "light",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (visibility.pricesInStores = !visibility.pricesInStores))
      }, null, 8, ["loading", "disabled"]),
      (props.buyingCount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.buyingCount), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(SilpoProductPriceChart, {
      "vendor-code": props.vendorCode,
      visible: visibility.prices,
      height: props.priceChartHeight,
      onPricesLoadingStart: _cache[2] || (_cache[2] = ($event: any) => (lock.pricesLoading = true)),
      onPricesLoadingFinish: _cache[3] || (_cache[3] = ($event: any) => (lock.pricesLoading = false))
    }, null, 8, ["vendor-code", "visible", "height"]),
    _createVNode(SilpoProductPricesInStores, {
      "vendor-code": props.vendorCode,
      visible: visibility.pricesInStores,
      date: date.value,
      onLoadingStart: _cache[4] || (_cache[4] = ($event: any) => (lock.pricesInStoresLoading = true)),
      onLoadingFinish: _cache[5] || (_cache[5] = ($event: any) => (lock.pricesInStoresLoading = false))
    }, null, 8, ["vendor-code", "visible", "date"])
  ], 8, _hoisted_1))
}
}

})